import { styled } from '@mui/material/styles';
import { FilePond } from 'react-filepond';

const StyledFilePond = styled(FilePond)`
  & a.filepond--credits {
    display: none;
  }

  & div.filepond--panel.filepond--panel-root {
    background-color: #fff;
    border: 1px solid rgba(15, 23, 42, 0.1);
    border-radius: 0.5rem;
  }

  & .filepond--drop-label {
    color: var(--secondary-text-color);
    font-family: var(--default-fonts);
  }

  & .filepond--label-action {
    color: var(--primary-color);
    text-decoration-color: var(--primary-color);
  }

  & .filepond--drip-blob,
  & .filepond--file-action-button {
    background-color: var(--primary-color);
  }

  & .filepond--file-status-main {
    font-family: var(--default-fonts);
  }
`;

export default StyledFilePond;
